<template>
  <div>
    <div class="noContainer" v-if="channelCount === 0">
      <no-data :imgSrc="noImgSrc" text="暂无频道可选" ></no-data>
    </div>
    <div class="container" v-else>
      <div class="contain">
        <h4 class="type-name" v-if="canUse.length > 0">{{btnMode === 1 ? '可用频道' : '请选择要在秒秒测智能日历上使用的日历(至多三个)'}}</h4>
        <style-unit
          v-for="(item) in canUse"
          v-if="loadSurvey"
          :key="item.index" :src="imgSrc"
          :model="item.model"
          :modelcn="item.modelcn"
          :name="item.name"
          :isUse="item.isUse"
          :price="item.price"
          :mode="btnMode"
          :id="item.channel_id"
          :selectLen="useId.length"
          :iconUrl="item.icon_url"
          :btnStr="item.btnStr"
          @preview="preview(item.ChannelPrice_id, item.ChannelPrice_name, item.channel_id, item.isUse, item.crowdfund)"
          @changeSelect="selctChannel">
        </style-unit>
        <h4 class="type-name" v-if="other.length > 0">付费频道</h4>
        <style-unit
          v-for="(item) in other"
          v-if="loadSurvey"
          :key="item.index" :src="imgSrc"
          :model="item.model"
          :modelcn="item.modelcn"
          :name="item.name"
          :isUse="item.isUse"
          :price="item.price"
          :mode="btnMode"
          :id="item.channel_id"
          :selectLen="useId.length"
          :iconUrl="item.icon_url"
          :btnStr="item.btnStr"
          @preview="preview(item.ChannelPrice_id, item.ChannelPrice_name, item.channel_id, item.isUse, item.crowdfund, 'other')"
          @changeSelect="selctChannel">
        </style-unit>
      </div>
      <button class="btn-block btn-save" @click="editSave">{{btnMode === 1 ? '编辑智能日历上的日历频道' : '确定'}}</button>
    </div>
    <ttip-select v-if="showSelectTip" text="确定退出编辑模式？" @cancel="cancel" @sure="sure"></ttip-select>
    <!-- <ttip-select2 v-if="tipShow2" @noshow="noshow"></ttip-select2> -->
    <setting-internet v-if="tipShow" @next="nextUpdate" @now="nowUpdate"></setting-internet>
  </div>
</template>
<script>
import StyleUnit from './components/styleUnit.vue'
import axios from 'axios'
import Common from '../../assets/js/common.js'
import NoData from '../../components/NoData/NoData.vue'
import TtipSelect from '../../components/TtipSelect/TtipSelect.vue'
import TtipSelect2 from '../../components/TtipSelect2/TtipSelect2.vue'
import SettingInternet from '../../components/SettingInternet/SettingInternet.vue'
var api = process.env.BASE_URL
var isLocal = Common.getEvn()

export default {
  components: {
    StyleUnit,
    NoData,
    TtipSelect,
    TtipSelect2,
    SettingInternet
  },
  data () {
    return {
      userId: localStorage.getItem('max_userId'),
      deviceId: localStorage.getItem('max_device_id'),
      imgSrc: Common.staticHref() + 'img/smallCanlender.jpg',
      noImgSrc: Common.staticHref() + 'img/settingIcon.jpg',
      channelCount: 0,
      allChannelLists: [],
      canUse: [],
      other: [],
      useId: [],
      checkedId: [],
      useIdBase: [],
      isFirst: true,
      channelIdStorage: Number(localStorage.getItem('max_channel_id')),
      btnMode: 1,
      showSelectTip: false,
      tipShow: false,
      tipShow2: false,
      loadSurvey: true
    }
  },
  methods: {
    pushHistory () {
      let state = {
        title: '',
        url: '/' + isLocal
      }
      window.history.pushState(state, state.title, state.url)
    },
    popstate () {
      if (this.btnMode === 2) {
        this.showSelectTip = !this.showSelectTip
        this.pushHistory()
      } else if (this.btnMode === 1) {
        // this.$router.back()
      }
    },
    verify () {
      var _this = this
      window.addEventListener('popstate', _this.popstate, false)
    },
    editSave () {
      if (this.btnMode === 1) {
        this.btnMode = 2
        this.pushHistory()
      } else {
        let useLen = this.useId.length
        if (useLen > 0 && !this.useId.equals(this.useIdBase)) {
          this.setChannel()
        } else if (useLen === 0) {
          this.$createToast({
            type: 'correct',
            txt: '请选择要使用的频道',
            time: 2000
          }).show()
        } else {
          this.btnMode = 1
          this.$router.back()
        }
      }
    },
    cancel () {
      this.showSelectTip = false
    },
    sure () {
      this.loadSurvey = false
      this.$nextTick(() => {
        this.loadSurvey = true
        this.getChannels()
      })
      this.showSelectTip = false
      this.btnMode = 1
      this.$router.back()
    },
    /* noshow () {
      this.tipShow2 = false
      localStorage.setItem('max_remind_agin', 'no')
    }, */
    nextUpdate () {
      this.tipShow = false
    },
    nowUpdate () {
      this.tipShow = false
      /* if (!localStorage.getItem('max_remind_agin')) {
        this.tipShow2 = true
      } */
    },
    selctChannel (e) {
      let id = e.id
      let checked = e.checked
      let idIndex = this.useId.indexOf(id)
      if (checked) {
        if (idIndex === -1) this.useId.push(id)
      } else {
        if (idIndex > -1) this.useId.splice(idIndex, 1)
      }
    },
    preview (priceId, price, channel, isUse, crowdfund, other) {
      if (channel === 5){
        crowdfund = false
      }
      // console.log('crowdfund------------>>>>'+ crowdfund)
      if (other === 'other') {
        this.$router.push({path: '/ChannelDetail', query: {priceId, price, channel, isUse, crowdfund, other}})
      } else {
        this.$router.push({path: '/ChannelDetail', query: {priceId, price, channel, isUse, crowdfund}})
      }
    },
    getChannels () {
      this.toast = this.$createToast({
        time: 0,
        txt: '正在加载',
        mask: true
      }).show()
      if (isLocal === 'local') {
        // console.log('-------->>>>>'+this.deviceId,this.userId)
        axios.post('/Calendar/api/channel/get/channel/', {
          'device_id': this.deviceId,
          'user_id': this.userId
        })
        .then(this.getChannelsSucc)
        .catch(this.getChannelsErr)
      } else {
        axios.post(api + '/Calendar/api/channel/get/channel/', {
          'device_id': this.deviceId,
          'user_id': this.userId
        })
        .then(this.getChannelsSucc)
        .catch(this.getChannelsErr)
      }
    },
    initChannelArr () {
      this.allChannelLists.splice(0, this.allChannelLists.length)
      this.canUse.splice(0, this.canUse.length)
      this.other.splice(0, this.other.length)
    },
    getChannelsSucc (res) {
      this.initChannes(res)
    },
    getChannelsErr (error) {
      this.toast.hide()
      console.log(error)
    },
    setChannel () {
      this.toast = this.$createToast({
        time: 0,
        txt: '正在设置频道',
        mask: true
      }).show()
      if (isLocal === 'local') {
        axios.post('/Calendar/api/channel/set/channel_on_use/', {
          'default': this.useId[0],
          'device_id': this.deviceId,
          'channel_on_use': this.useId
        })
        .then(this.setChannelSucc)
        .catch(this.setChannelErr)
      } else {
        axios.post(api + '/Calendar/api/channel/set/channel_on_use/', {
          'default': this.useId[0],
          'device_id': this.deviceId,
          'channel_on_use': this.useId
        })
        .then(this.setChannelSucc)
        .catch(this.setChannelErr)
      }
    },
    setChannelSucc (res) {
      this.toast.hide()
      this.btnMode = 1
      this.$router.back()
      this.tipShow = true
      this.initChannes(res)
    },
    setChannelErr (error) {
      this.toast.hide()
      console.log('1111111111111111')
      console.log(error)
    },
    initChannes (res) {
      // console.log('列表------->>>>>' + JSON.stringify(_res))
      console.log(res)
      let useLen = this.useId.length
      let useLenBase = this.useIdBase.length
      if (useLen > 0) this.useId.splice(0, useLen)
      if (useLenBase > 0) this.useIdBase.splice(0, useLenBase)
      this.toast.hide()
      let _res = res.data
      if (!_res) return false
      if (_res.result === 0) {
        this.initChannelArr()
        this.channelCount = _res.channels.all.count
        if (this.channelCount === 0) return false
        this.allChannelLists = _res.channels.all.channel_list
        let boughtLen = _res.channels.bought.count
        let boughtList = _res.channels.bought.channel_list
        let crowdfunding = _res.channels.bought.crowdfunding
        // console.log('列表------->>>>>' + crowdfunding)
        let onuseLen = _res.channels.on_use.count
        let onuseList = _res.channels.on_use.channel_list
        this.allChannelLists.forEach((elem, i) => {
          elem.index = i
          elem.isUse = false
          let isbught = false
          let price = elem.ChannelPrice_name
          let channelID = Number(elem.channel_id)
          // console.log(this.channelIdStorage, channelID)
          elem.modelcn = '未使用'
          elem.btnStr = '查看'
          if (onuseLen !== 0) {
            for (var f = 0; f < onuseLen; f++) {
              if (channelID === onuseList[f].channel_id) {
                this.useId.push(channelID)
                this.useIdBase.push(channelID)
                elem.modelcn = '使用中'
                elem.isUse = true
                onuseList.splice(f, 1)
                onuseLen--
                break
              }
            }
          }
          if (price === 0 ) {
            elem.crowdfund = false
            elem.model = 'free'
            elem.price = ''
            this.canUse.push(elem)
          } else {
            if(crowdfunding === true){
              elem.crowdfund = true
            }
            if (boughtLen === 0) {
              elem.model = 'noBuy'
              elem.modelcn = '收费'
              elem.price = price + '元'
              elem.btnStr = '查看并购买'
              this.other.push(elem)
              return
            }
            for (let i = 0; i < boughtLen; i++) {
              let name = boughtList[i].name
              if (elem.name === name) {
                isbught = true
                boughtList.splice(i, 1)
                boughtLen--
                break
              }
            }
            if (isbught) {
              elem.model = 'isbuy'
              elem.price = ''
              this.canUse.push(elem)
            }
            else {
              elem.model = 'noBuy'
              elem.modelcn = '收费'
              elem.price = price + '元'
              elem.btnStr = '查看并购买'
              this.other.push(elem)
            }
          }
        })
      } else {
        console.log(_res.message)
      }
    }
  },
  mounted () {
    this.getChannels()
  },
  activated () {
    this.verify()
    Common.setTitle('频道列表')
    if (this.isFirst) {
      this.isFirst = false
      return false
    }
    let fromPage = localStorage.getItem('max_channel_from')
    let isChange = localStorage.getItem('max_channel_change')
    let deviceId = localStorage.getItem('max_device_id')
    if (fromPage === 'Main' && deviceId !== this.deviceId) {
      this.deviceId = deviceId
      this.getChannels()
    } else if (fromPage === 'detail' && isChange === 'true') {
      this.getChannels()
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~styles/mixins.styl"
.container
  position relative
  padding-top 20px
  box-sizing border-box
  colCenter()
  .contain
    height calc(97.5vh - 70px)
    overflow auto
    width 100%
  .type-name
    color #000000
    font-size 14px
    height 30px
    line-height 18px
    box-sizing border-box
    padding-bottom 12px
    width 330px
    margin 0 auto
  .btn-save
    bottom 2.487vh
</style>



// WEBPACK FOOTER //
// src/pages/CutStyle/CutStyle.vue